export const API_PATH_ApiDeviceMgmtDeviceArchive = '/services/devices-mgtm/apiDeviceMgmtDeviceArchive';
